export default __webpack_public_path__ + "static/media/img (1).b75d0e27.jpg";